export async function downloadRemoteFile(url, filename) {
  const safeName = filename || 'documento'
  try {
    const response = await fetch(url)
    if (!response.ok) throw new Error('Falha ao baixar')
    const blob = await response.blob()
    const objectUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = safeName
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(objectUrl)
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

export function downloadDocumentFile(file) {
  if (!file?.file_url) return
  const name = file.file_name || file.title || 'documento'
  return downloadRemoteFile(file.file_url, name)
}
